import { Stack, Text, useToast, Spinner, Icon } from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useEffect } from 'react';

import { BsCheckLg } from "react-icons/bs";
import { POST } from "../../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";

export default function Login() {
    const toast = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const user = useSelector((state: any) => state.user.value);

    useEffect(() => {
        if (searchParams.get("vt")) {
            (async () => {
                const res = await POST(
                    `/api/user/verify/${searchParams.get("vt")}`
                );

                toast({
                    status: res.status,
                    title: res.message,
                    duration: 1000,
                    position: 'top-right',
                    isClosable: true
                })

                if (res.status === 'success') {
                    setIsLoading(false);
                    setTimeout(() => {
                        navigate('/');
                    }, 4000);
                } else {
                    navigate('/');
                }
            })()
        } else {
            toast({
                status: "error",
                title: "Something went Wrong!",
                description: "An unexpected error occured while proceeding your request.",
                duration: 1000,
                position: 'top-right',
                isClosable: true
            });
            navigate('/');
        }
        setTimeout(() => {
            setIsLoading(false);
        }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (user?.role) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <Stack
            w={'full'}
            h={"100vh"}
            justify={'center'}
            align={"center"}
            py={32}
        >
            <Text mb={2} fontSize='2xl' color='textColor.headingColor' fontWeight={'bold'}>
                Thank you for signing up on Entry Bot
            </Text>
            <Stack
                p={6}
                w={'md'}
                spacing={3}
                rounded={'2xl'}
                boxShadow={'base'}
                justify={'center'}
                align={'center'}
            >
                {
                    isLoading ?
                        (
                            <>
                                <Text>Please wait while we verify your account.</Text>
                                <Spinner
                                    thickness='4px'
                                    speed='0.65s'
                                    color='primary.400'
                                    size='xl'
                                />
                            </>
                        )
                        :
                        (
                            <>
                                <Text>Your account has activated!</Text>
                                <Text>Please wait while we redirect you to the login page.</Text>
                                <Icon
                                    as={BsCheckLg}
                                    h={'35px'}
                                    w={'35px'}
                                    color={'green.400'}
                                />
                            </>
                        )
                }
            </Stack>
        </Stack>
    )
}